/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetOrganizationPaymentSchemes200ResponseInnerInner
 */
export interface GetOrganizationPaymentSchemes200ResponseInnerInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPaymentSchemes200ResponseInnerInner
     */
    'paymentMethod': GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPaymentSchemes200ResponseInnerInner
     */
    'externalAccountTransferAgency': GetOrganizationPaymentSchemes200ResponseInnerInnerExternalAccountTransferAgencyEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationPaymentSchemes200ResponseInnerInner
     */
    'paymentScheme': GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentSchemeEnum;
}

export const GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentMethodEnum = {
    accountTransfer: 'ACCOUNT_TRANSFER',
    bankTransfer: 'BANK_TRANSFER'
} as const;

export type GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentMethodEnum = typeof GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentMethodEnum[keyof typeof GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentMethodEnum];
export const GetOrganizationPaymentSchemes200ResponseInnerInnerExternalAccountTransferAgencyEnum = {
    moneyForwardKessai: 'MONEY_FORWARD_KESSAI',
    ufj: 'UFJ'
} as const;

export type GetOrganizationPaymentSchemes200ResponseInnerInnerExternalAccountTransferAgencyEnum = typeof GetOrganizationPaymentSchemes200ResponseInnerInnerExternalAccountTransferAgencyEnum[keyof typeof GetOrganizationPaymentSchemes200ResponseInnerInnerExternalAccountTransferAgencyEnum];
export const GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentSchemeEnum = {
    fifteenthDayPayment: 'FIFTEENTH_DAY_PAYMENT',
    twoMonthsLaterFifteenthDayPayment: 'TWO_MONTHS_LATER_FIFTEENTH_DAY_PAYMENT',
    endOfTwoMonthsLaterPayment: 'END_OF_TWO_MONTHS_LATER_PAYMENT',
    twentiethDayPayment: 'TWENTIETH_DAY_PAYMENT',
    endOfMonthPayment: 'END_OF_MONTH_PAYMENT',
    twoMonthsLaterSixthDayPayment: 'TWO_MONTHS_LATER_SIXTH_DAY_PAYMENT'
} as const;

export type GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentSchemeEnum = typeof GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentSchemeEnum[keyof typeof GetOrganizationPaymentSchemes200ResponseInnerInnerPaymentSchemeEnum];


